import { ModalDialog } from 'commons/components';
import styled from 'styled-components';

export const CustomFieldStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 4px 0;
    cursor: pointer;

    > div {
        display: flex;
        flex-direction: column;

        owc-typography {
            padding-left: 12px;
        }
    }

    owc-icon {
        padding-right: 8px;
        cursor: pointer;
    }

    &:hover {
        background-color: var(--one-color-interaction-hover-brand-lower);
    }
`;

export const CustomFieldModalStyled = styled(ModalDialog)`
    owc-typography {
        padding: 4px 0 8px;
        color: var(--one-color-gray-600);
    }

    /* OWC-OVERRIDE: a horizontal radio group must not stretch across the form, or its options
       drift apart. owc-radio-group fills its container in v7.6.0 and exposes no width prop. */
    .owc-radio-group.owc-radio-group--direction-horizontal {
        width: fit-content;
    }
`;
